/* eslint-disable no-undef */
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import MenuBarHome from '../../components/Home/MenuBar/MenuBarHome';
import MenuProfile from '../../components/MenuProfile/MenuProfile';
import { ContainerPages } from '../../components/Containers';
import TemplateListProjectsAndCreateAndEdit from '../../templates/SincronizaNFe/List';

export default function SincronizaListProjects(props) {
  const { userInfo } = useSelector((state) => state.userSign);

  useEffect(() => {
    if (!userInfo) {
      props.history.push('/login');
    }
    if (userInfo !== null) {
      if (
        userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_ADMIN_SINCRONIZA_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_USER_SINCRONIZA_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS
      ) {
        props.history.push('/sincroniza-nfe');
      } else {
        props.history.push('/login');
      }
    }
  }, [userInfo, props.history]);

  return (
    <ContainerPages>
      <MenuProfile />
      <MenuBarHome />
      <TemplateListProjectsAndCreateAndEdit />
    </ContainerPages>
  );
}
